import { render, staticRenderFns } from "./SemiologiaPediatrica.vue?vue&type=template&id=c7685f6a"
import script from "./SemiologiaPediatrica.vue?vue&type=script&lang=js"
export * from "./SemiologiaPediatrica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports